(() => {
  const enhance = () => {
    const container = document.querySelector('#MainContent .shopify-email-marketing-confirmation__container');
    if (!container || container.dataset.pwUnsubscribe === 'true') return;
    container.dataset.pwUnsubscribe = 'true';
    document.body.classList.add('pw-unsubscribe');
    const heading = container.querySelector('h1');
    if (heading && heading.childElementCount === 0) heading.textContent = 'Email preferences';
    const routeRoot = window.Shopify?.routes?.root;
    const shopRoot = typeof routeRoot === 'string' && /^\/(?!\/)/.test(routeRoot) ? routeRoot : '/';
    const newsletterEmail = () => document.querySelector('#ContactFooter input[type="email"][name="contact[email]"]');
    const actions = document.createElement('div');
    actions.className = 'pw-unsubscribe__actions';
    const subscribeLink = document.createElement('a');
    subscribeLink.className = 'pw-unsubscribe__action pw-unsubscribe__subscribe';
    subscribeLink.dataset.pwUnsubscribeSubscribe = 'true';
    subscribeLink.textContent = 'Subscribe again';
    subscribeLink.href = newsletterEmail() ? '#ContactFooter' : shopRoot + '#ContactFooter';
    subscribeLink.addEventListener('click', (event) => {
      if (event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const email = newsletterEmail();
      if (!email || email.disabled) return;
      event.preventDefault();
      email.closest('form').scrollIntoView({ behavior: 'smooth', block: 'center' });
      email.focus({ preventScroll: true });
    });
    const returnLink = document.createElement('a');
    returnLink.className = 'pw-unsubscribe__action pw-unsubscribe__return';
    returnLink.dataset.pwUnsubscribeReturn = 'true';
    returnLink.textContent = 'Return to shop';
    returnLink.href = shopRoot;
    actions.append(subscribeLink, returnLink);
    container.append(actions);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
})();
